export function confirmOpenBankingPayoutV1(send) {
  return (query, ...args) =>
    send(
      {
        path: '/v1/openbanking/payouts/confirmPayments',
        pathParameters: {},
        type: 'get',
        query: query,
        body: undefined,
        headers: undefined,
        auth: 'oauth2',
        contentType: undefined,
      },
      ...args
    );
}
